import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import $ from 'jquery';

import { addUrlProps, UrlQueryParamTypes } from 'react-url-query';
import { configureUrlQuery } from 'react-url-query';
import createHistory from 'history/createBrowserHistory';

import { loadCategories, loadArticles } from './lib/DataHelpers';
import { findById, toggleCategory, setCategoryActive, updateCategories } from './lib/FilterHelpers';
import CategoryCheckBox from './Components/CategoryCheckBox';
import CategoryResults from './Components/CategoryResults';
import FilterCheckBox from './Components/FilterCheckBox';

import './App.css';

import vegetarian_icon from './img/vegetarian.svg';
import vegan_icon from './img/vegan.svg';
import gluten_free_icon from './img/gluten_free.svg';
import lactose_free_icon from './img/lactose_free.svg';

require('./sticky-kit');

const history = createHistory();
configureUrlQuery({ history });

const urlPropsQueryConfig = {
  cats: { type: UrlQueryParamTypes.string },
  showAll: { type: UrlQueryParamTypes.string },
  isVegan: { type: UrlQueryParamTypes.boolean },
  isVegetarian: { type: UrlQueryParamTypes.boolean },
  isWholeFood: { type: UrlQueryParamTypes.boolean },
  isLightWholeFood: { type: UrlQueryParamTypes.boolean },
  isCare: { type: UrlQueryParamTypes.boolean },
  isGlutenFree: { type: UrlQueryParamTypes.boolean },
  isLactoseFree: { type: UrlQueryParamTypes.boolean },
  searchText: { type: UrlQueryParamTypes.string },
};


class App extends Component {
  constructor(...args) {
    super(...args)

    this.state = {
      categories: [],
      allCategoriesActive: true,
      isVegan: false,
      isVegetarian: false,
      isWholeFood: false,
      isLightWholeFood: false,
      isCare: false,
      isGlutenFree: false,
      isLactoseFree: false,
      allergeneSearchText: '',
      searchText: '',
      cats: '',
      showAll: '',
      noArticles: true,
    };

    this.loadAllData = this.loadAllData.bind(this);
    this.checkCategories = this.checkCategories.bind(this);
    this.handleToggleAllCategories = this.handleToggleAllCategories.bind(this);
    this.handleCategoryToggle = this.handleCategoryToggle.bind(this);
    this.handleToggleIsVegetarian = this.handleToggleIsVegetarian.bind(this);
    this.handleToggleIsVegan = this.handleToggleIsVegan.bind(this);
    this.handleToggleIsWholeFood = this.handleToggleIsWholeFood.bind(this);
    this.handleToggleIsLightWholeFood = this.handleToggleIsLightWholeFood.bind(this);
    this.handleToggleIsCare = this.handleToggleIsCare.bind(this);
    this.handleToggleIsGlutenFree = this.handleToggleIsGlutenFree.bind(this);
    this.handleToggleIsLactoseFree = this.handleToggleIsLactoseFree.bind(this);
    this.handleAllergeneSearchTextChange = this.handleAllergeneSearchTextChange.bind(this);
    this.handleSearchTextChange = this.handleSearchTextChange.bind(this);
    this.handleResetAll = this.handleResetAll.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this);
    this.handleLoadAll = this.handleLoadAll.bind(this);
    this.handleAllergeneSearchTextClick = this.handleAllergeneSearchTextClick.bind(this);
    this.handleSearchTextClick = this.handleSearchTextClick.bind(this);
    this.handleSearchTextSubmit = this.handleSearchTextSubmit.bind(this);
  }


  static propTypes = {
    // URL props are automatically decoded and passed in based on the config
    cats: PropTypes.string,
    showAll: PropTypes.string,
    isVegan: PropTypes.bool,
    isVegetarian: PropTypes.bool,
    isWholeFood: PropTypes.bool,
    isLightWholeFood: PropTypes.bool,
    isCare: PropTypes.bool,
    isGlutenFree: PropTypes.bool,
    isLactoseFree: PropTypes.bool,
    searchText: PropTypes.string,

    // change handlers are automatically generated when given a config.
    // By default they update that single query parameter and maintain existing
    // values in the other parameters.
    onChangeCats: PropTypes.func,
    onChangeShowAll: PropTypes.func,
    onChangeIsVegan: PropTypes.func,
    onChangeIsVegetarian: PropTypes.func,
    onChangeIsWholeFood: PropTypes.func,
    onChangeIsLightWholeFood: PropTypes.func,
    onChangeIsCare: PropTypes.func,
    onChangeIsGlutenFree: PropTypes.func,
    onChangeIsLactoseFree: PropTypes.func,
    onChangeSearchText: PropTypes.func,
  }

  static defaultProps = {
    cats: '',
    showAll: '',
    isVegan: false,
    isVegetarian: false,
    isWholeFood: false,
    isLightWholeFood: false,
    isCare: false,
    isGlutenFree: false,
    isLactoseFree: false,
    searchText: '',
  }

  loadAllData = function() {
    this.setState({
      isLoading: true
    }, function() {
      let categories = [...this.state.categories]
      var noArticles = true

      categories.forEach(function(category) {
        loadArticles(this.state.isVegetarian, this.state.isVegan, this.state.isWholeFood, this.state.isLightWholeFood, this.state.isCare, this.state.isGlutenFree, this.state.isLactoseFree, this.state.allergeneSearchText, this.state.searchText, category.id.toString(), category.limit).then( function(json) {
          if (json && json.items && json.items.length > 0){
            noArticles = false
          }

          if (json.meta.total_count > category.limit) {
            category.moreAvailable=true
          } else {
            category.moreAvailable=false
          }
          category.articles = json.items

          this.setState({
            categories: categories,
            noArticles: noArticles,
            isLoading: false
          }, () => {

          })
        }.bind(this))
      }.bind(this))

      /*categories.forEach((category) => {
        category.articles = []
      })

      loadArticles(this.state.isVegetarian, this.state.isVegan, this.state.isWholeFood, this.state.isLightWholeFood, this.state.isCare, this.state.isGlutenFree, this.state.isLactoseFree, this.state.allergeneSearchText, this.state.searchText, '').then( json => {
        var noArticles = false
        if (json.items.length ===  0){
          noArticles = true
        }
        json.items.forEach((article) => {
          let category = findById(article.category.id, categories)
          category.articles.push(article)
        })
        this.setState({
          categories: categories,
          noArticles: noArticles,
          isLoading: false
        })
      })*/
    }.bind(this))
  }

  componentDidMount() {
    var allActive = this.props.cats==='' ? true : false;

    $("#filter-menu").stick_in_parent({recalc_every: 1});

    this.setState({
      isVegan: this.props.isVegan,
      isVegetarian: this.props.isVegetarian,
      isWholeFood: this.props.isWholeFood,
      isLightWholeFood: this.props.isLightWholeFood,
      isCare: this.props.isCare,
      isGlutenFree: this.props.isGlutenFree,
      isLactoseFree: this.props.isLactoseFree,
      searchText: this.props.searchText,
      cats: this.props.cats,
      showAll: this.props.showAll,
      allCategoriesActive: allActive,
    }, function() {
      loadCategories().then( function (categories) {
        var cats = this.state.cats.split('-')
        var showAll = this.state.showAll.split('-')

        categories.forEach( function(category) {
          if (this.state.cats !== ''){
            category.isActive = false
            cats.forEach( function(cat) {
              if (String(category.id) === cat) {
                category.isActive = true
              }
            })
          } else {
            category.isActive = true
          }

          if (this.state.showAll !== ''){
            category.limit='6'
            showAll.forEach( function(cat) {
              if (String(category.id) === cat) {
                category.limit='1000'
              }
            })
          } else {
            category.limit='6'
          }
        }.bind(this))
        this.setState({
          categories: categories
        }, function() {
          this.loadAllData()
        }.bind(this))
      }.bind(this))
    }.bind(this))
  }

  checkCategories = function() {
    let allActive = true
    let noArticles = true
    this.state.categories.forEach(function(category) {
      allActive = allActive && category.isActive
      if (category.isActive === true) {
        noArticles = false
      }
    })
    // let res = this.state.categories.reduce((a, b) => ((a.isActive && b.isActive) ? b.isActive : false));
    this.setState({
      allCategoriesActive: allActive,
      noArticles: noArticles,
    })
  }


  handleToggleAllCategories = function(){
    this.setState({allCategoriesActive: !this.state.allCategoriesActive}, function() {
      let updatedCategories = this.state.categories
      this.state.categories.forEach( function(category) {
        let updatedCategory = setCategoryActive(category, this.state.allCategoriesActive)
        updatedCategories = updateCategories(updatedCategories, updatedCategory)
      }.bind(this))
      this.setState({
        categories: updatedCategories,
      }, function() {
        if (this.state.allCategoriesActive === false) {
          this.setState({noArticles: true})
        } else {
          this.setState({noArticles: false})
        }
        let new_cats = []
        updatedCategories.forEach( function(cat) {
          if (cat.isActive) {
            new_cats.push(String(cat.id))
          }
          this.props.onChangeCats(new_cats.join('-'))
        }.bind(this))
      }.bind(this))
    }.bind(this))
  }

  handleCategoryToggle = function(id) {
    const category = findById(id, this.state.categories)
    const toggled = toggleCategory(category)
    const updatedCategories = updateCategories(this.state.categories, toggled)
    this.setState({categories: updatedCategories}, function() {
      let new_cats = []
      updatedCategories.forEach( function(cat) {
        if (cat.isActive) {
          new_cats.push(String(cat.id))
        }
        this.props.onChangeCats(new_cats.join('-'))
      }.bind(this))
      this.checkCategories()
    }.bind(this))
  }

  handleToggleIsVegetarian = function() {
    this.setState({isVegetarian: !this.state.isVegetarian}, function() {
      this.props.onChangeIsVegetarian(this.state.isVegetarian)
      this.loadAllData()
    }.bind(this))
  }

  handleToggleIsVegan = function() {
    this.setState({isVegan: !this.state.isVegan}, function() {
      this.props.onChangeIsVegan(this.state.isVegan)
      this.loadAllData()
    }.bind(this))
  }

  handleToggleIsWholeFood = function() {
    this.setState({isWholeFood: !this.state.isWholeFood}, function() {
      this.props.onChangeIsWholeFood(this.state.isWholeFood)
      this.loadAllData()
    }.bind(this))
  }

  handleToggleIsLightWholeFood = function() {
    this.setState({isLightWholeFood: !this.state.isLightWholeFood}, function() {
      this.props.onChangeIsLightWholeFood(this.state.isLightWholeFood)
      this.loadAllData()
    }.bind(this))
  }

  handleToggleIsCare = function() {
    this.setState({isCare: !this.state.isCare}, function() {
      this.props.onChangeIsCare(this.state.isCare)
      this.loadAllData()
    }.bind(this))
  }

  handleToggleIsGlutenFree = function() {
    this.setState({isGlutenFree: !this.state.isGlutenFree}, function() {
      this.props.onChangeIsGlutenFree(this.state.isGlutenFree)
      this.loadAllData()
    }.bind(this))
  }

  handleToggleIsLactoseFree = function() {
    this.setState({isLactoseFree: !this.state.isLactoseFree}, function() {
      this.props.onChangeIsLactoseFree(this.state.isLactoseFree)
      this.loadAllData()
    }.bind(this))
  }

  handleAllergeneSearchTextChange = function(evt) {
    this.setState({
      allergeneSearchText: $('#allergeneField').val()
    })
  }

  handleAllergeneSearchTextClick = function(evt) {
    this.loadAllData()
  }

  handleSearchTextChange = function(evt) {
    this.setState({
      searchText: evt.target.value
    })
  }

  handleSearchTextClick = function(evt) {
    this.loadAllData()
  }

  handleSearchTextSubmit = function(evt) {
    if (evt.keyCode === 13) {
        this.loadAllData()
        return false;
    }
  }


  handleResetAll = function() {
    this.setState({
      allCategoriesActive: false,
      isVegan: false,
      isVegetarian: false,
      isWholeFood: false,
      isLightWholeFood: false,
      isCare: false,
      isGlutenFree: false,
      isLactoseFree: false,
      allergeneSearchText: '',
      searchText: '',
    }, function() {
      this.props.onChangeIsVegetarian(this.state.isVegetarian)
      this.props.onChangeIsVegan(this.state.isVegan)
      this.props.onChangeIsWholeFood(this.state.isWholeFood)
      this.props.onChangeIsLightWholeFood(this.state.isLightWholeFood)
      this.props.onChangeIsCare(this.state.isCare)
      this.props.onChangeIsGlutenFree(this.state.isGlutenFree)
      this.props.onChangeIsLactoseFree(this.state.isLactoseFree)
      this.props.onChangeSearchText(this.state.searchText)
      this.props.onChangeShowAll('')
      this.props.onChangeCats('')

      this.setState({allCategoriesActive: true}, function() {
        let updatedCategories = this.state.categories
        this.state.categories.forEach( function(category) {
          let updatedCategory = setCategoryActive(category, this.state.allCategoriesActive)
          updatedCategory.limit = '6'
          updatedCategories = updateCategories(updatedCategories, updatedCategory)
        }.bind(this))
        this.setState({categories: updatedCategories}, function() {
          this.loadAllData()
        }.bind(this))
      }.bind(this))
    })
  }

  toggleFilter = function() {
    $('#filter-menu').toggle();
    $(".filter-menu").stick_in_parent();
  }

  handleLoadAll = function(categoryId) {
    let categories = [...this.state.categories]
    let category = findById(categoryId, categories)
    category.articles = []
    category.limit='1000'

    loadArticles(this.state.isVegetarian, this.state.isVegan, this.state.isWholeFood, this.state.isLightWholeFood, this.state.isCare, this.state.isGlutenFree, this.state.isLactoseFree, this.state.allergeneSearchText, this.state.searchText, categoryId.toString(), category.limit).then( function(json) {
      category.articles = json.items
      category.moreAvailable = false

      let new_showAll = []
      categories.forEach( function(cat) {
        if (cat.limit === '1000') {
          new_showAll.push(String(cat.id))
        }
        this.props.onChangeShowAll(new_showAll.join('-'))
      }.bind(this))

      this.setState({
        categories: categories,
      })
    }.bind(this))
  }


  render() {
    return (
      <div className="maincontent">
        <div className="toggle-filter-wrapper">
          <div className="toggle-filter" onClick={this.toggleFilter}>Filter</div>
        </div>
        <div className="filter-bg" id="filter-bg" >
          <div className="filter-menu" id="filter-menu">
            <div className="close-filter" onClick={this.toggleFilter}>«</div>
            <div className="filter-header">Produkte</div>

            <div className="filter-block">
              <div className="checkbox-wrapper" style={{marginBottom: 20}}>
                <input
                  type="checkbox"
                  checked={this.state.allCategoriesActive} />
                <label className="filter-category" onClick={this.handleToggleAllCategories}>
                  Alle/keine Produkte
                </label>
              </div>

              {this.state.categories.map( function(category) {
                return (
                <CategoryCheckBox
                  key={category.id}
                  isActive={category.isActive}
                  handleToggle={this.handleCategoryToggle}
                  {...category} />
                )}.bind(this))}
            </div>

            <div className="filter-block">
              <FilterCheckBox
                isActive={this.state.isVegetarian}
                handleToggle={this.handleToggleIsVegetarian}
                title='Vegetarisch'
                icon={vegetarian_icon} />

              <FilterCheckBox
                isActive={this.state.isVegan}
                handleToggle={this.handleToggleIsVegan}
                title='Vegan'
                icon={vegan_icon} />

            </div>

            <div className="filter-block">
              <div className="filter-subheader">Verpflegungsstufe</div>

              <FilterCheckBox
                isActive={this.state.isWholeFood}
                handleToggle={this.handleToggleIsWholeFood}
                title='VK Vollkost'/>

              <FilterCheckBox
                isActive={this.state.isLightWholeFood}
                handleToggle={this.handleToggleIsLightWholeFood}
                title='LVK Leichte Vollkost'/>

              <FilterCheckBox
                isActive={this.state.isCare}
                handleToggle={this.handleToggleIsCare}
                title='SK Schonkost'/>
            </div>

            <div className="filter-block">
              <div className="filter-subheader">Allergenfreiheit</div>
              <FilterCheckBox
                isActive={this.state.isGlutenFree}
                handleToggle={this.handleToggleIsGlutenFree}
                title='Glutenfrei'
                icon={gluten_free_icon}/>

              <FilterCheckBox
                isActive={this.state.isLactoseFree}
                handleToggle={this.handleToggleIsLactoseFree}
                title='Laktosefrei'
                icon={lactose_free_icon} />

              <input
                  type="text"
                  id="allergeneField"
                  value={this.state.allergeneSearchText}
                  onChange={this.handleAllergeneSearchTextChange}
                  onKeyDown={this.handleSearchTextSubmit}
                  style={{marginTop: 20}}
                  placeholder="z.B. Nüsse, Sellerie" />
                  {/*
              <button onClick={this.handleAllergeneSearchTextClick}>
                go
              </button>*/}
            </div>

            <div className="filter-block">
              <div className="filter-subheader">Suche</div>
              <input
                  type="text"
                  id="searchTextField"
                  value={this.state.searchText}
                  onChange={this.handleSearchTextChange}
                  onKeyDown={this.handleSearchTextSubmit}
                  placeholder="Artikel-Nr., Suchtext" />
              {/*<button onClick={this.handleSearchTextClick}>
                go
              </button>*/}

            </div>

            <div className="filter-block">
              <div onClick={this.handleResetAll}
                  className="filter-reset">
                Alle Filter zurücksetzen
              </div>
            </div>
          </div>


          {this.state && this.state.noArticles && (
            <div className="filter-empty">Zu den gewählten Filtereinstellungen gibt es leider keine Ergebnisse!</div>
          )}

          <div className="filter-results">

            {this.state.categories.map( function(category) {
              return(
              <CategoryResults
                key={category.id}
                handleLoadAll={this.handleLoadAll}
                {...category} />
            )}.bind(this))}
          </div>

        </div>
      </div>
    );
  }
}

export default addUrlProps({ urlPropsQueryConfig })(App);



// WEBPACK FOOTER //
// ./src/App.js